module.exports = __webpack_public_path__ + "img/CL-light.a29dea24.png";